import PropTypes from 'prop-types'

/**
 * @typedef {Object} DashboardState
 * @property {number} total_unique_users
 * @property {number} active_users
 * @property {number} portals_online
 * @property {number} new_users
 * @property {number} net_sales
 * @property {number} total_orders
 */

export const dashboardPropTypes = PropTypes.shape({
  total_unique_users: PropTypes.number,
  active_users: PropTypes.number,
  portals_online: PropTypes.number,
  new_users: PropTypes.number,
  net_sales: PropTypes.number,
  total_orders: PropTypes.number
})

/** @type {DashboardState} */
const initialState = {
  total_unique_users: 0,
  active_users: 0,
  portals_online: 0,
  new_users: 0,
  net_sales: 0,
  total_orders: 0
}

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case 'SET_DASHBOARD':
      return payload
    default:
      return state
  }
}
